<template>
  <div id="cabecalho">
    <nav>
      <div class="container-logo-sp w-100 d-flex">
        <div class="m-3 pr-1 w-50">
          <a
            class="logo-sebrae-sp"
            href="http://www.sebrae.com.br/"
            target="_blank"
            rel="noopener"
            title="Sebrae"
          >
            <img
              alt="Sebrae"
              height="50"
              src="~@/assets/images/logo-sebrae-sp-azul.svg"
            />
          </a>
        </div>
        <div class="d-flex flex-row-reverse w-50 align-self-center">
          <button @click="logoff" class="btn-logoff" title="Logout">
            <i class="fa fa-power-off"></i>
          </button>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  name: "Cabecalho",
  methods: {
    logoff() {
      this.$keycloak.logout();
    },
  },
};
</script>
<style>
.btn-logoff {
  border: none;
  background-color: Transparent;
  background-repeat: no-repeat;
}
.container-logo-sp {
  background-color: #0075bf;
}
.logo-sebrae-sp {
  margin-left: 30px;
  margin-top: 10px;
}
.fa-power-off {
  color: #ffffff;
  margin-right: 30px;
}
</style>